import { Marker } from 'react-leaflet';
import L, { LeafletMouseEvent } from 'leaflet';
import deviceIcon from '../../icons/device-icon.svg';
import useDevice from 'hooks/useDevice';
import { useMapStore } from 'contexts/RootStore.context';
import useMap from 'views/map/hooks/useMap';
import { observer } from 'mobx-react';
import { Device } from 'types/device';
import { DeviceDetailsTooltip } from '../ToolTips/DeviceDetailsTooltip';
import DeviceIdTooltip from '../ToolTips/DeviceIdTooltip';
import { useState } from 'react';

export const DeviceMarker = observer(({ device }: { device: Device }) => {
  const { filterForm, selectedDevice, setSelectedDevice,
    // to force re-render on map move and show the tooltips
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    mapMoveVersion
  } = useMapStore()
  const { panToLatLong, isMarkerVisible } = useMap(useMapStore());
  const { isMobileDevice } = useDevice();
  const [loading, setLoading] = useState(false)

  const deviceIsSelected = selectedDevice?.device_id === device.device_id

  const markerLong = device.location.coordinates.longitude;
  const markerLat = device.location.coordinates.latitude;

  function handleMarkerClick(e: LeafletMouseEvent) {
    setLoading(true)
    setSelectedDevice(device)?.then(() => {
      setLoading(false)
    })
    panToLatLong(e.latlng);
  }

  const customIcon = new L.Icon({
    iconUrl: deviceIcon,
    iconSize: new L.Point(20, 20),
    iconAnchor: [10, 10], // half of icon size.
    className: 'leaflet-custom-icon',
  });

  return (
    <Marker
      title={`${device.device_id}`}
      eventHandlers={{
        click: (e) => {
          handleMarkerClick(e);
        },
      }}
      icon={customIcon}
      position={[markerLat, markerLong]}
    >
      {deviceIsSelected && !isMobileDevice && (
        <DeviceDetailsTooltip loading={loading} handleCloseInfoBox={() => setSelectedDevice(null)} />
      )}
      {!deviceIsSelected && filterForm.$.displayDeviceId.value && isMarkerVisible(device) &&
        <DeviceIdTooltip device={device} />}
    </Marker>
  );
})
